import { useContext } from 'react';
import { AuthContext } from '../lib/auth/AuthProvider';
import { logout } from '../api/auth';
import type { SessionUser } from '../lib/auth/types';

const initialsOf = (user: SessionUser): string => {
  const trimmedName = user.displayName?.trim();
  const source = trimmedName && trimmedName.length > 0 ? trimmedName : user.email.split('@')[0];
  const parts = source.split(/[\s._-]+/).filter((p) => p.length > 0);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export function NavbarUser() {
  const ctx = useContext(AuthContext);
  const user = ctx?.user;

  if (!user) return null;

  const onLogout = async () => {
    try {
      await logout();
    } finally {
      window.location.assign('/api/auth/login');
    }
  };

  const name = user.displayName ?? user.email;
  const initials = initialsOf(user);

  return (
    <div className="user-card" data-testid="navbar-user-card">
      <div className="avatar" aria-hidden="true" data-testid="navbar-user-avatar">
        {initials}
      </div>
      <div className="meta">
        <span className="name" data-testid="navbar-user">
          {name}
        </span>
        <span className="email" data-testid="navbar-user-email">
          {user.email}
        </span>
      </div>
      <button
        type="button"
        className="logout"
        onClick={onLogout}
        data-testid="navbar-logout"
      >
        Abmelden
      </button>
    </div>
  );
}
